var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0159 1.52425L12.5813 3.78276L16.0159 6.04127C18.4235 6.04127 20.3823 8.00013 20.3823 10.4077V12.8168L22.6408 15.0753L24.8993 12.8168V10.4077C24.8993 5.50942 20.9142 1.52425 16.0159 1.52425V1.52425Z",
    fill: "#9EA2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9116 3.78276C14.9116 2.89982 15.3192 2.06634 16.016 1.52425C11.1177 1.52425 7.13257 5.50942 7.13257 10.4077V12.8168L9.39108 15.0753L11.6496 12.8168V10.4077C11.6496 8.00013 13.6084 6.04127 16.016 6.04127C15.3192 5.49917 14.9116 4.66569 14.9116 3.78276Z",
    fill: "#8288CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7045 12.8167H12.8499V30.4758H25.7045C26.9723 30.4758 28 29.4445 28 28.1724V15.1201C28 13.848 26.9723 12.8167 25.7045 12.8167Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1454 28.1724V15.1201C15.1454 13.848 16.1732 12.8167 17.4409 12.8167H6.2955C5.02775 12.8167 4 13.848 4 15.1201V28.1724C4 29.4445 5.02775 30.4758 6.2955 30.4758H17.4409C16.1732 30.4758 15.1454 29.4445 15.1454 28.1724Z",
    fill: "#FFB357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9cd50a3961f27ffcb5ecf4ad14e98bf0.svg";
export { ForwardRef as ReactComponent };